module.exports = __webpack_public_path__ + "static/img/0203_02.ef5535a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0203_02.png
// module id = vEeO
// module chunks = 1